import React from 'react';
import PropTypes from 'prop-types';

export default function PlayIcon({ size }) {
  return (
    <svg width={size} height="100%" viewBox="0 0 16 22">
      <path d="M0 0v22l16-11z" fillRule="evenodd" />
    </svg>
  );
}

PlayIcon.propTypes = {
  size: PropTypes.number,
};

PlayIcon.defaultProps = {
  size: 16,
};



// WEBPACK FOOTER //
// ./src/components/icons/PlayIcon/index.js